import { Button, Flex, Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import { Icons } from 'src/common/components'

import { useDeleteLocation } from '../../hooks/useDeleteLocation.hook'

interface DeleteClinicModalProps {
  locationId: string
}

const DeleteLoctionContent = ({ locationId }: DeleteClinicModalProps) => {
  const { onSubmit, isLoading } = useDeleteLocation(locationId)

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit()
      }}
    >
      <Stack align="center" justify="center" gap="md">
        <Icons.Warning width="60" height="60" color="red" />
        <Text size={'16px'} fw={700} style={{ color: 'red' }}>
          Confirm Location Removal
        </Text>
        <Text size={'14px'} fw={400} style={{ whiteSpace: 'pre-wrap' }}>
          Are you sure you want to delete this Location?
        </Text>
        <Text size={'14px'} fw={400} style={{ whiteSpace: 'pre-wrap' }}>
          This action cannot be undone. Removing this location will revoke their
          from to the system
        </Text>
      </Stack>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button color="red" loading={isLoading} type="submit" variant="filled">
          Delete Location
        </Button>
      </Flex>
    </form>
  )
}

export const openLocationDeleteModal = (locationId: string) => {
  return modals.open({
    title: null,
    centered: true,
    withCloseButton: true,
    size: 'md',
    children: <DeleteLoctionContent locationId={locationId} />,
  })
}
